// src/services/authService.js
import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: "https://login.microsoftonline.com/aa845867-f433-44b3-9ed6-3df09a7761ac",
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

const scopes = [
    '499b84ac-1321-427f-aa17-267ca6975798/user_impersonation'
];

class AuthService {
    constructor() {
        this.msalInstance = new PublicClientApplication(msalConfig);
    }

    async initialize() {
        await this.msalInstance.initialize();
        try {
            // Handle the redirect flow
            const response = await this.msalInstance.handleRedirectPromise();
            if (response) {
                // If we have a response, we've just completed the authentication
                return true;
            }
            // Check if we have an account even if there was no response
            return !!this.getAccount();
        } catch (error) {
            console.error('Error during initialization:', error);
            return false;
        }
    }

    async login() {
        try {
            const response = await this.msalInstance.loginPopup({ scopes });
            return response;
        } catch (err) {
            console.error('Login error:', err);
            throw err;
        }
    }

    async getToken() {
        try {
            const account = this.getAccount();
            if (!account) {
                throw new Error('No active account');
            }

            const silentRequest = {
                scopes,
                account
            };

            try {
                const response = await this.msalInstance.acquireTokenSilent(silentRequest);
                return response.accessToken;
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    const response = await this.msalInstance.acquireTokenPopup(silentRequest);
                    return response.accessToken;
                }
                throw error;
            }
        } catch (error) {
            console.error('Get token error:', error);
            throw error;
        }
    }

    getAccount() {
        const currentAccounts = this.msalInstance.getAllAccounts();
        if (currentAccounts.length === 0) {
            return null;
        }
        return currentAccounts[0];
    }

    async logout() {
        try {
            await this.msalInstance.logoutPopup();
        } catch (err) {
            console.error('Logout error:', err);
        }
    }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;